import { writeConfig } from './cli/cli.utils';
import { exists } from './helpers/exist';

export const name = '@bemedev/cli-setupFs';

export const getSetupFiles = async (
  prevSetupFiles: string[],
  _setupFiles: string[],
) => {
  const path = await requirePath();

  const setupFiles = [...prevSetupFiles, path, ..._setupFiles];
  return setupFiles;
};

export const requirePath = async () => {
  const { check, path } = exists();
  if (!check) await writeConfig();
  return path;
};
